
import * as defaultImport from "@splunk/themes/getTheme";
export * from "@splunk/themes/getTheme";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
